// src/lib/http.ts
import axios from "axios";
import { API_BASE } from "./config";
import { getApiKey } from "./apiKey";
import { getClientId } from "./clientId";

// Safe join helper for links like `${API_BASE}/docs`
export function apiUrl(path: string) {
  const base = API_BASE.replace(/\/+$/, "");
  const p = String(path || "").startsWith("/") ? path : `/${path}`;
  return `${base}${p}`;
}

// If you already have this, keep your existing config and just ensure baseURL = API_BASE
export const http = axios.create({
  baseURL: API_BASE,
  timeout: 30_000,
});

http.interceptors.request.use((config) => {
  const k = getApiKey();
  config.headers = config.headers ?? {};
  if (k) {
    (config.headers as any)["X-API-Key"] = k;
  } else {
    (config.headers as any)["X-Client-Id"] = getClientId();
    (config.headers as any)["X-Client-Mode"] = "anon";
  }
  return config;
});

export async function httpGet(path: string, opts?: { signal?: AbortSignal; headers?: Record<string, string> }) {
  const apiKey = getApiKey();
  const p = String(path || "").startsWith("/") ? path : `/${path}`;
  const headers: Record<string, string> = {
    Accept: "application/json",
    ...(opts?.headers ?? {}),
  };
  if (apiKey) headers["X-API-Key"] = apiKey;
  else {
    headers["X-Client-Id"] = getClientId();
    headers["X-Client-Mode"] = "anon";
  }

  const res = await fetch(`${API_BASE}${p}`, {
    method: "GET",
    headers,
    signal: opts?.signal,
  });

  const json = await res.json().catch(() => null);
  if (!res.ok) {
    const err: any = new Error("http error");
    err.status = res.status;
    err.json = json ?? {};
    throw err;
  }
  // Successful status with no parseable body (e.g. 204 No Content)
  return json ?? {};
}
